import fetchNow from './_Fetch.jsx';

const ClusterAPI = {
    getAll: () => {
        return fetchNow('/api/cluster/all', 'GET');
    }
}
 
export default ClusterAPI;